import './PageLayout.css'
import PageHeader from './PageHeader'

function PageLayout({
  children,
  title,
  heroContent,
  noCard = false,
  heroVariant = 'default',
  showHeader = true,
}) {
  return (
    <div className="page-container">
      {showHeader && <PageHeader />}
      <div
        className={`page-hero ${
          heroVariant === 'compact' ? 'page-hero--compact' : ''
        } d-flex justify-content-center align-items-center`}
      >
        <div className="page-header">
          {heroContent || <h1 className="page-title">{title}</h1>}
        </div>
      </div>
      <div className="page-content">
        {noCard ? (
          <div className="page-content-nocard">{children}</div>
        ) : (
          <div className="content-card">{children}</div>
        )}
      </div>
    </div>
  )
}

export default PageLayout
